import { Validator } from '@vista-digital/validator';
import { buttonColorValidator } from '../../../button/types/color';
import { buttonIconPositionValidator } from '../../../button/types/icon-position';
import { buttonSizeValidator } from '../../../button/types/size';
export const formButtonConfigValidator = Validator.object({
    show: Validator.boolean(),
    size: buttonSizeValidator,
    color: buttonColorValidator,
    iconPosition: buttonIconPositionValidator
});
